"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getChartOptions = exports.assignXValue = exports.getChartHeight = void 0;
var MAX_CHART_HEIGHT = 100000;
function getChartHeight(numOfBars) {
    var base = 100;
    return Math.min(MAX_CHART_HEIGHT, numOfBars * base + 300);
}
exports.getChartHeight = getChartHeight;
function breakDownSeries(seriesData) {
    var breakDownSeries = [];
    seriesData.forEach(function (row) {
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, high: row.base }));
        breakDownSeries.push(__assign(__assign({}, row), { ol: row.low, oh: row.high, low: row.base }));
    });
    return breakDownSeries;
}
function breakDownSeriesMean(seriesData, chartInverted) {
    var breakDownSeries = [];
    seriesData.forEach(function (row) {
        if (row.mean != 0) {
            breakDownSeries.push(row.mean);
        }
    });
    if (!chartInverted) {
        breakDownSeries = adjustBias(breakDownSeries);
    }
    return breakDownSeries;
}
function adjustBias(seriesData) {
    var adjustedBiasSeries = [];
    adjustedBiasSeries = seriesData.map(function (value) {
        return value + (0.08 * value); // Deduct 10%
    });
    return adjustedBiasSeries;
}
function generateSeries(dataRows, legends, zindex, chartInverted, meanLabel) {
    if (zindex === void 0) { zindex = 6; }
    var series = [];
    var seriesMean = [];
    var bias = -0.2;
    var _loop_1 = function (legend) {
        if (legends.length > 1) {
            bias = -0.4;
        }
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) {
            return item.colorTag === tagKey;
        });
        if (seriesData.length > 0) {
            series.push({
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': breakDownSeries(seriesData)
            });
            seriesMean = seriesMean.concat(breakDownSeriesMean(seriesData, chartInverted));
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    if (meanLabel) {
        series.push({
            'name': "<div><strong>X</strong> | Mean</div>",
            'data': seriesMean.sort(function (a, b) {
                return b - a;
            }),
            "color": 'rgba(0,0,0,0)',
            "showInLegend": true,
            dataLabels: {
                enabled: true,
                align: 'center',
                formatter: function () {
                    var point = this.point;
                    return 'X';
                },
                style: {
                    fontSize: '12px',
                    color: 'black'
                }
            },
            events: {
                legendItemClick: function (e) {
                    e.preventDefault(); // Prevent clicking on the legend
                }
            }
        });
    }
    return series;
}
function assignXValue(mainSeriesData, siblingSeriesData) {
    var totalBars = mainSeriesData.length;
    mainSeriesData.forEach(function (row, index) {
        row.x = index;
    });
    if (siblingSeriesData && siblingSeriesData.length > 0) {
        var positionFix_1 = 0.42;
        mainSeriesData.forEach(function (row, index) {
            for (var _i = 0, siblingSeriesData_1 = siblingSeriesData; _i < siblingSeriesData_1.length; _i++) {
                var sibRow = siblingSeriesData_1[_i];
                if (!sibRow.x && sibRow.name === row.name) {
                    sibRow.x = index + positionFix_1;
                    break;
                }
            }
        });
        siblingSeriesData.filter(function (row) { return !row.x; }).forEach(function (row) {
            var rowCopy = __assign(__assign({}, row), { x: totalBars, y: 0 });
            // siblingSeriesData.push(rowCopy);
            row.x = totalBars + positionFix_1;
            totalBars += 1;
        });
    }
    return totalBars;
}
exports.assignXValue = assignXValue;
function sortFunction(a, b) {
    return b.mean - a.mean;
}
function getChartOptions(graph, options) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp, chartInverted = options.chartInverted;
    var legendsEnabled = (options['legendsEnabled'] != false);
    var chartWidth = options['legendsEnabled'] == false ? 400 : 580;
    var marginRight = options['legendsEnabled'] == false ? 0 : 50;
    var marginTop = options['legendsEnabled'] == false ? 70 : 30;
    var meanLabel = graph.meanLabel ? graph.meanLabel : true;
    var mainSeriesData = (graph.mainRows || []).sort(sortFunction);
    var siblingSeriesData = (graph.siblingRows || []).sort(sortFunction);
    var totalBars = assignXValue(mainSeriesData, siblingSeriesData);
    var chartHeight = getChartHeight(totalBars);
    var series = generateSeries(mainSeriesData, legends, 6, chartInverted, meanLabel);
    var drilldown = (graph.mainDrillDown || []).map(function (dd) {
        dd.data = breakDownSeries(dd.data);
        return dd;
    });
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5, chartInverted, meanLabel);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown.map(function (dd) {
            dd.data = breakDownSeries(dd.data);
            return dd;
        }));
    }
    return {
        chart: {
            renderTo: 'chartContainer',
            zoomType: 'xy',
            marginRight: marginRight,
            marginTop: marginTop,
            type: 'columnrange',
            inverted: chartInverted,
            // events: {
            //     load: function () {
            //         var chart = this;
            //         setTimeout(function () {
            //             handleResponsiveNess(chart)
            //         }, 0); // Using setTimeout to ensure it's applied after rendering
            //     }
            // }
            height: chartHeight
        },
        credits: {
            enabled: legendsEnabled,
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        legend: {
            enabled: legendsEnabled
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                enabled: true,
                text: graph.yTitle // units
            }
        },
        tooltip: {
            shared: true,
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.points[0] && this.points[0].point && this.points[0].point.name) {
                    var point = this.points[0].point;
                    return "<b>" + point.name + "</b> <i>(" + point.series.name + ")</i><br />" +
                        ("10 is: <b>" + point.ol.toFixed(settings.decimals) + "</b>; ") +
                        ("50 is: <b>" + point.base.toFixed(settings.decimals) + "</b>; ") +
                        ("90 is: <b>" + point.oh.toFixed(settings.decimals) + "</b>; ") +
                        ("Mean: <b>" + point.mean.toFixed(settings.decimals) + "</b>; ");
                }
                else {
                    return false;
                }
            }
        },
        plotOptions: {
            columnrange: {
                pointPadding: 0,
                grouping: false
            }
        },
        series: series,
        responsive: {
            rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            enabled: false
                        }
                    }
                }]
        },
        drilldown: {
            series: drilldown
        }
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=compare-uncertainty.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-uncertainty2/compare-uncertainty.chart.js